export function getCode(state) {
  return state.deviceDiscovery.code;
}
